// Vue Router — com guard de autenticação
// Rota protegida exige token; / é o mapa principal

import { createRouter, createWebHistory } from 'vue-router';
import { tokenStore } from '@/lib/api';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'map',
      component: () => import('@/views/MapView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/import',
      name: 'import',
      component: () => import('@/views/ImportView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
  ],
});

// Guard: bloqueia rotas protegidas sem token; manda logado longe do /login
router.beforeEach((to) => {
  const authed = !!tokenStore.getAccess();

  if (to.meta.requiresAuth && !authed) {
    return { name: 'login' };
  }
  if (to.name === 'login' && authed) {
    return { name: 'map' };
  }
  return true;
});

export default router;
